"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListSubheader = _interopRequireDefault(require("@mui/material/ListSubheader"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _TrendingFlat = _interopRequireDefault(require("@mui/icons-material/TrendingFlat"));
var _ArrowUpward = _interopRequireDefault(require("@mui/icons-material/ArrowUpward"));
var _ArrowDownward = _interopRequireDefault(require("@mui/icons-material/ArrowDownward"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Remove = _interopRequireDefault(require("@mui/icons-material/Remove"));
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _Unstable_Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2"));
var _reactI18next = require("react-i18next");
var _colors = require("@mui/material/colors");
var List = function List(_ref) {
  var data = _ref.data;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var theme = (0, _styles.useTheme)();
  var getTrendingColor = function getTrendingColor(state) {
    var sign = Math.sign(state);
    if (sign > 0) {
      return theme.palette.success.main;
    } else if (sign === 0) {
      return theme.palette.info.main;
    } else {
      return theme.palette.warning.main;
    }
  };
  var getTrendingIcon = function getTrendingIcon(state) {
    var sign = Math.sign(state);
    if (sign > 0) {
      return /*#__PURE__*/_react.default.createElement(_ArrowUpward.default, {
        role: "image"
      });
    } else if (sign === 0) {
      return /*#__PURE__*/_react.default.createElement(_TrendingFlat.default, {
        role: "image"
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, {
        role: "image"
      });
    }
  };
  var getCollapseIcon = function getCollapseIcon(state) {
    return state ? /*#__PURE__*/_react.default.createElement(_Remove.default, {
      role: "image",
      sx: {
        color: theme.palette.text.primary,
        pr: 1
      }
    }) : /*#__PURE__*/_react.default.createElement(_Add.default, {
      role: "image",
      sx: {
        color: theme.palette.text.primary,
        pr: 1
      }
    });
  };
  var handleClick = function handleClick(item) {
    if (item.date === selected.date) {
      setSelected({});
    } else {
      setSelected(item);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    className: "data-list"
  }, data.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      className: "data-list-item",
      key: item.date,
      divider: true,
      disableGutters: true,
      disablePadding: true
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
      sx: {
        color: getTrendingColor(item.changeMaximum),
        pl: 1
      }
    }, getTrendingIcon(item.changeMaximum)), /*#__PURE__*/_react.default.createElement(_ListItemButton.default, {
      onClick: function onClick() {
        return handleClick(item);
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      flex: "1",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1",
      sx: {
        color: theme.palette.text.primary
      }
    }, t('intlDateLong', {
      val: new Date(item.date)
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle2",
      sx: {
        color: theme.palette.text.primary
      }
    }, t('intlCurrencyShort', {
      val: item.maximum
    }))), getCollapseIcon(selected.date == item.date))), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
      in: selected.date === item.date,
      orientation: "vertical",
      timeout: "auto",
      className: "data-list-collapse"
    }, /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
      md: 4,
      flex: "1"
    }, /*#__PURE__*/_react.default.createElement(_Card.default, {
      className: "card-for-list"
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1"
    }, t('maximum')), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle2"
    }, t('intlCurrencyShort', {
      val: item.maximum
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        color: getTrendingColor(item.changeMaximum)
      },
      variant: "caption"
    }, t('intlCurrencyShort', {
      val: item.changeMaximum
    }))))), /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
      md: 4,
      flex: "1"
    }, /*#__PURE__*/_react.default.createElement(_Card.default, {
      className: "card-for-list"
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1"
    }, t('minimum')), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle2"
    }, t('intlCurrencyShort', {
      val: item.minimum
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        color: getTrendingColor(item.changeMinimum)
      },
      variant: "caption"
    }, t('intlCurrencyShort', {
      val: item.changeMinimum
    }))))), /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
      md: 4,
      flex: "1"
    }, /*#__PURE__*/_react.default.createElement(_Card.default, {
      className: "card-for-list"
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle1"
    }, t('modal')), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "subtitle2"
    }, t('intlCurrencyShort', {
      val: item.modal
    })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        color: getTrendingColor(item.changeModal)
      },
      variant: "caption"
    }, t('intlCurrencyShort', {
      val: item.changeModal
    }))))))));
  }));
};
exports.List = List;